import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";

import {
  Screen1,
  Points,
  Learn,
  Who,
  Program,
  Speaker,
  Revs,
  Advance
} from "../../../components/LandingTemplates/kids_career";

const TITLE = 'Профориентация детей | Центр образовательных технологий Advance';
const DESCRIPTION = 'Что делать родителям, у которых ребёнок хочет быть только блогером или вообще ничего не хочет?';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'bf3e77c910d1e5c4925b4381fba3793c8f2e3ecb'} id={'1319768'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'kids_career_e'} widget={widget}/>
      <Points/>
      <Learn widget={widget}/>
      <Who/>
      <Program widget={widget}/>
      <Speaker/>
      <Revs widget={widget}/>
      <Advance widget={widget}/>
    </main>

    <FooterFull/>

  </DefaultLayout>
);
export default Page;
